// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsFranchises_ProvidersInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for GET /subaccounts/franchises/providers
 *
 * Optional country filter for the active payment providers listing.
 */
import { registerContract } from './validate'

export interface SubaccountsFranchises_ProvidersInput {
country_code?: string
}

registerContract('SubaccountsFranchises_ProvidersInput', {
  country_code: { type: 'string',  required: false },
})
